'use client';
import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL, UPLOAD_URL } from '../config/config';

// Create the context
const ProductDetailsContext = createContext();

// Helper to parse saree_finishings field
const parseSareeFinishings = (raw) => {
  if (!raw) return [];

  try {
    const [labelsRaw, pricesRaw] = raw.split(':');

    const labels = labelsRaw
      .replace(/[\[\]]/g, '')
      .split(',')
      .map((l) => l.trim());

    const prices = pricesRaw
      .replace(/[\[\]]/g, '')
      .split(',')
      .map((p) => parseFloat(p.trim()));

    return labels.map((label, index) => ({
      label,
      price: prices[index] ?? 0,
    }));
  } catch (err) {
    console.error('❌ Failed to parse saree_finishings:', err);
    return [];
  }
};

// Provider component
export const ProductDetailsProvider = ({ children, productId }) => {
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchProductDetails = async (id) => {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_URL}/products/${id}`);

      if (response.data?.status === 200 && response.data.data?.length > 0) {
        const data = response.data.data[0];

        let imageArray = [];
        if (data.images) {
          imageArray = data.images
            .split(',')
            .map((img) => img.trim())
            .filter(Boolean)
            .map((img) => `${UPLOAD_URL}/products/${img}`);
        }

        const formatted = {
          ...data, // spread all original fields
          id: Number(data.id),
          amount: parseFloat(data.amount.replace(/,/g, '')),
          quantity: Number(data.quantity),
          images: imageArray,
          saree_finishings: parseSareeFinishings(data.saree_finishings),
        };


        setProduct(formatted);
      } else {
        console.log('No product data found for this ID.');
        setProduct(null);
      }
    } catch (err) {
      console.error('❌ Failed to fetch product details:', err);
      setProduct(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  if (productId) {
    setProduct(null); // Clear previous product
    fetchProductDetails(productId);
  }
}, [productId]);



  return (
    <ProductDetailsContext.Provider value={{ product, loading }}>
      {children}
    </ProductDetailsContext.Provider>
  );
};

// Custom hook to use product details
export const useProductDetails = () => useContext(ProductDetailsContext);
